// import PropTypes from "prop-types";

import ChartkickChart from "../../../shared_components/chartkick_chart";

class GlobalHistogramChart extends ChartkickChart {
}

GlobalHistogramChart.propTypes = Object.assign({}, ChartkickChart.propTypes, {

});

export default GlobalHistogramChart;
